import apis from "@/api";


export const allProvinceSymbol = {
  provinceId: "all",
  provinceCode: "000000",
  provinceName: "全部"
};

const defaultCity = {
  cityId: "1",
  cityName: "北京市"
};

export const stationApiConfig = {
  trainStation: {
    getStationPage: apis.getTrainStationPage,
    modifyStation: apis.modifyTrainStation,
    addStation: apis.addTrainStation
  },

  airport: {
    getStationPage: apis.getAirportPage,
    modifyStation: apis.modifyAirport,
    addStation: apis.addAirport
  }
};

export const tableColumns = {
  trainStation: [
    {
      title: "火车站名称",
      key: "trainStationName",
      align: "center",
      minWidth: 120
    },
    { title: "英文名称", key: "englishName", align: "center", minWidth: 120 },
    { title: "车站编码", key: "code", align: "center", minWidth: 120 },
    { title: "车站代号", key: "mark", align: "center", minWidth: 120 },
    { title: "所在城市", key: "cityName", align: "center", minWidth: 120 },
    { title: "操作", slot: "action", width: 150, align: "center" }
  ],
  airport: [
    {
      title: "飞机场名称",
      key: "airportName",
      align: "center",
      minWidth: 120
    },
    { title: "所在城市", key: "cityName", align: "center", minWidth: 120 },
    { title: "操作", slot: "action", width: 150, align: "center" }
  ]
};

export const initStationForm = {
  trainStationName: "",
  airportName: "",
  acronym: "",
  code: "",
  mark: "",
  englishName: "",
  ...defaultCity
};
